import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';
import { SettingsService } from '../services/settings/settings.service';
import { AUTH_SESSION_REQUEST } from '../services/auth/auth-http.context';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    private readonly settingsService = inject(SettingsService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (req.method === 'JSONP') {
            return next.handle(req);
        }

        const language$ = req.context.get(AUTH_SESSION_REQUEST)
            ? this.settingsService.currentLang$.pipe(take(1))
            : this.settingsService.currentLang$;
        return language$.pipe(
            switchMap((language) => {
                // Klonování požadavku a přidání hlavičky
                const modifiedReq = req.clone({
                    headers: req.headers.set('Accept-Language', language.code),
                });

                // Pokračování v requestu
                return next.handle(modifiedReq);
            })
        );
    }
}
